import './TextArea.css';

import { FocusEvent, MouseEvent, Ref } from 'react';
import { IonLabel } from '@ionic/react';
import clsx from 'clsx';
import { FilterError } from '../../../../../types/types';
import InputErrorMessage from '../../../InputErrorMessage/InputErrorMessage';

interface TextAreaProps {
  onChange?: (value: string) => void;
  value: string;
  name?: string;
  label?: string;
  error?: FilterError;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  inputRef?: Ref<HTMLTextAreaElement>;
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: FocusEvent<HTMLTextAreaElement>) => void;
  onClick?: (event: MouseEvent<HTMLTextAreaElement>) => void;
  hideErrorText?: boolean;
  rows: number;
}

export default function TextArea({
  onChange,
  error = null,
  value,
  name,
  label,
  required,
  disabled = false,
  className,
  placeholder,
  inputRef = undefined,
  onBlur = () => {},
  onFocus = () => {},
  onClick = () => {},
  hideErrorText = false,
  rows = 1,
}: TextAreaProps) {
  const handleChange = (e) => {
    if (onChange) {
      const value = e.target.value as string;
      const filteredValue = value;
      onChange(filteredValue);
    }
  };

  return (
    <div className={clsx('input-container', className)}>
      {label && <IonLabel>{label}</IonLabel>}
      <textarea
        rows={rows}
        {...(label && {
          title: label,
        })}
        required={required}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        {...(error && {
          'aria-invalid': true,
          'aria-errormessage': `error-${name}`,
        })}
        ref={inputRef}
        {...(placeholder && {
          placeholder,
        })}
        onClick={onClick}
        className={clsx('input-element', error && 'input-error')}
        autoComplete="off"
      />
      {!hideErrorText && <InputErrorMessage error={error} />}
    </div>
  );
}
